export enum ENumericIntervalMode {
  single = 'single',
  interval = 'interval',
  singleAndInterval = 'singleAndInterval',
}
